import type { Lang } from "@noli/core";

export enum Project_Words {
  "header_menu_tip" = "header_menu_tip",
  "header_cloud_tip" = "header_cloud_tip",
  "cloud_project_switch" = "cloud_project_switch",
  "cloud_project_create" = "cloud_project_create",
  "cloud_project_rename" = "cloud_project_rename",
  "cloud_project_rename_label" = "cloud_project_rename_label",
  "cloud_project_rename_failed_toast" = "cloud_project_rename_failed_toast",
  "cloud_project_rename_success_toast" = "cloud_project_rename_success_toast",
  "current_project_lost_id" = "current_project_lost_id",
  "select_a_cloud_project" = "select_a_cloud_project",
  "cloud_project_switch_header" = "cloud_project_switch_header",
  "cancel_button" = "cancel_button",
  "switch_cloud_project_button_text" = "switch_cloud_project_button_text",
  "save_as_new_project_reason" = "save_as_new_project_reason",
  "cloud_project_switch_success" = "cloud_project_switch_success",
  "cloud_project_switch_failed" = "cloud_project_switch_failed",
  "cloud_project_create_success" = "cloud_project_create_success",
  "cloud_project_create_failed" = "cloud_project_create_failed",
  "create_cloud_project_header" = "create_cloud_project_header",
  "rename_for_new_project" = "rename_for_new_project",
  "create_new_project_button_text" = "create_new_project_button_text",
  "cloud_project_name_sensitive_toast" = "cloud_project_name_sensitive_toast",
  "scroll_load_more" = "scroll_load_more",
  "cancel_all_nolibox_tasks" = "cancel_all_nolibox_tasks",
  "cloud_project_shown_all" = "cloud_project_shown_all",
  "cloud_save_tooltip_with_time" = "cloud_save_tooltip_with_time",
  "cloud_save_info_with_time" = "cloud_save_info_with_time",
  "cloud_saving" = "cloud_saving",
  "replace_cancel_task_tip" = "replace_cancel_task_tip",
  "replace_cancel_tasks_confirm" = "replace_cancel_tasks_confirm",
  "replace_cancel_tasks_cancel" = "replace_cancel_tasks_cancel",
  "cancel_tasks_success" = "cancel_tasks_success",
  "cancel_tasks_failed" = "cancel_tasks_failed",
  "create_project_cancel_tasks_tip" = "create_project_cancel_tasks_tip",
  "create_project_cancel_tasks_confirm" = "create_project_cancel_tasks_confirm",
  "cloud_switch_modal_update_time" = "cloud_switch_modal_update_time",
  "cloud_switch_modal_current_project" = "cloud_switch_modal_current_project",
  "cloud_switch_modal_enter_project" = "cloud_switch_modal_enter_project",
  "cloud_switch_modal_delete_project" = "cloud_switch_modal_delete_project",
  "cloud_switch_modal_download_project" = "cloud_switch_modal_download_project",
  "cloud_switch_modal_load_more" = "cloud_switch_modal_load_msubmitToPublicore",
  "cloud_project_header_op_icon_tooltip" = "cloud_project_header_op_icon_tooltip",
  "cloud_project_delete_modal_warn" = "cloud_project_delete_modal_warn",
  "cloud_project_delete_modal_confirm" = "cloud_project_delete_modal_confirm",
  "cloud-save-success-message" = "cloud-save-success-message",
  "cloud-save-failed-message" = "cloud-save-failed-message",
}

export const projectLangRecords: Record<Lang, Record<Project_Words, string>> = {
  zh: {
    [Project_Words["header_menu_tip"]]: "菜单",
    [Project_Words["header_cloud_tip"]]: "保存到云端",
    [Project_Words["cloud_project_switch"]]: "切换云端项目",
    [Project_Words["cloud_project_create"]]: "新建项目",
    [Project_Words["cloud_project_rename"]]: "重命名当前项目",
    [Project_Words["cloud_project_rename_label"]]: "当前项目重命名为",
    [Project_Words["cloud_project_rename_failed_toast"]]: "项目名更新失败！",
    [Project_Words["cloud_project_rename_success_toast"]]: "项目名更新成功",
    [Project_Words["current_project_lost_id"]]: "当前项目发生了一些错误",
    [Project_Words["select_a_cloud_project"]]: "请选择一个云端项目！",
    [Project_Words["cloud_project_switch_header"]]: "云端项目管理",
    [Project_Words["cancel_button"]]: "取消",
    [Project_Words["switch_cloud_project_button_text"]]: "切换项目",
    [Project_Words["save_as_new_project_reason"]]:
      "检测到云端有更新版本，已为您将本地项目另存为新项目：",
    [Project_Words["cloud_project_switch_success"]]: "项目已切换到",
    [Project_Words["cloud_project_switch_failed"]]: "项目切换失败",
    [Project_Words["cloud_project_create_success"]]: "创建项目成功，正在切换项目...",
    [Project_Words["cloud_project_create_failed"]]: "新建项目失败！",
    [Project_Words["create_cloud_project_header"]]: "新建项目",
    [Project_Words["rename_for_new_project"]]: "为新项目命名",
    [Project_Words["create_new_project_button_text"]]: "新建项目",
    [Project_Words["cloud_project_name_sensitive_toast"]]: "检测到敏感词汇，请重新输入",
    [Project_Words["cloud_project_shown_all"]]: "没有更多项目了~",
    [Project_Words["cloud_save_tooltip_with_time"]]: "于 $ 云保存",
    [Project_Words["cloud_save_info_with_time"]]: "$ 已云保存",
    [Project_Words["cloud_saving"]]: "正在云保存...",
    [Project_Words["scroll_load_more"]]: "滚动加载更多",
    [Project_Words["cancel_all_nolibox_tasks"]]: "取消全部画宇宙任务",
    [Project_Words["replace_cancel_task_tip"]]: "切换项目将取消当前全部任务 😳 您确定要切换吗？",
    [Project_Words["replace_cancel_tasks_confirm"]]: "切换项目",
    [Project_Words["replace_cancel_tasks_cancel"]]: "返回",
    [Project_Words["cancel_tasks_success"]]: "已取消全部画宇宙任务",
    [Project_Words["cancel_tasks_failed"]]: "取消任务失败",
    [Project_Words["create_project_cancel_tasks_tip"]]:
      "新建项目将取消当前全部任务 😳 您确定要新建吗？",
    [Project_Words["create_project_cancel_tasks_confirm"]]: "新建项目",
    [Project_Words["cloud_switch_modal_update_time"]]: "更新于 $",
    [Project_Words["cloud_switch_modal_current_project"]]: "当前项目",
    [Project_Words["cloud_switch_modal_enter_project"]]: "进入项目",
    [Project_Words["cloud_switch_modal_delete_project"]]: "删除项目",
    [Project_Words["cloud_switch_modal_download_project"]]: "下载 .noli 到本地",
    [Project_Words["cloud_switch_modal_load_more"]]: "滚动加载更多",
    [Project_Words["cloud_project_header_op_icon_tooltip"]]: "项目操作",
    [Project_Words["cloud_project_delete_modal_warn"]]: "确认删除“$”，一经删除将无法找回",
    [Project_Words["cloud_project_delete_modal_confirm"]]: "删除",
    [Project_Words["cloud-save-success-message"]]: "云端保存成功！🥳",
    [Project_Words["cloud-save-failed-message"]]:
      "云端保存失败，请检查您的网络环境 😫 为保证数据不丢失，可将项目保存到本地 😉",
  },
  en: {
    [Project_Words["header_menu_tip"]]: "Menu",
    [Project_Words["header_cloud_tip"]]: "Save",
    /* 云端项目 */
    [Project_Words["cloud_project_switch"]]: "Switch Project to ...",
    [Project_Words["cloud_project_create"]]: "Create New Project",
    [Project_Words["cloud_project_rename"]]: "Rename Project",
    [Project_Words["cloud_project_rename_label"]]: "Rename current project as",
    [Project_Words["cloud_project_rename_failed_toast"]]: "Failed to rename current project 😫",
    [Project_Words["cloud_project_rename_success_toast"]]: "Successfully renamed project!",
    [Project_Words["current_project_lost_id"]]: "Something went wrong with current project 😫",
    [Project_Words["select_a_cloud_project"]]: "Please select a project",
    [Project_Words["cloud_project_switch_header"]]: "Project Management",
    [Project_Words["cancel_button"]]: "Cancel",
    [Project_Words["switch_cloud_project_button_text"]]: "Switch",
    [Project_Words["save_as_new_project_reason"]]:
      "Newer version is detected from cloud, your local project is saved as a new project: ",
    [Project_Words["cloud_project_switch_success"]]: "Current project has already switched to",
    [Project_Words["cloud_project_switch_failed"]]: "Failed to switch project 😫",
    [Project_Words["cloud_project_create_success"]]:
      "New project created successfully, replacing project",
    [Project_Words["cloud_project_create_failed"]]: "Failed to create a new project 😫",
    [Project_Words["create_cloud_project_header"]]: "Create New Project",
    [Project_Words["rename_for_new_project"]]: "nominate new project",
    [Project_Words["create_new_project_button_text"]]: "Create",
    [Project_Words["cloud_project_name_sensitive_toast"]]:
      "The project name contains sensitive word, please modify and try again",
    [Project_Words["cloud_project_shown_all"]]: "There's no more ~",
    [Project_Words["cloud_save_tooltip_with_time"]]: "Save at $",
    [Project_Words["cloud_save_info_with_time"]]: "Save at $",
    [Project_Words["cloud_saving"]]: "Saving...",
    [Project_Words["scroll_load_more"]]: "scroll to load more",
    [Project_Words["cancel_all_nolibox_tasks"]]: "Cancel All Nolibox Tasks",
    [Project_Words["replace_cancel_task_tip"]]:
      "All Nolibox tasks will be cancelled when replacing project 😳 are u sure to continue?",
    [Project_Words["replace_cancel_tasks_confirm"]]: "Continue",
    [Project_Words["replace_cancel_tasks_cancel"]]: "Cancel",
    [Project_Words["cancel_tasks_success"]]: "All Nolibox tasks cancelled successfully",
    [Project_Words["cancel_tasks_failed"]]: "Failed to cancel tasks 😫",
    [Project_Words["create_project_cancel_tasks_tip"]]:
      "All Nolibox tasks will be cancelled when creating a new project 😳 are u sure to continue?",
    [Project_Words["create_project_cancel_tasks_confirm"]]: "Continue",
    [Project_Words["cloud_switch_modal_update_time"]]: "Update at $",
    [Project_Words["cloud_switch_modal_current_project"]]: "Current project",
    [Project_Words["cloud_switch_modal_enter_project"]]: "Switch",
    [Project_Words["cloud_switch_modal_delete_project"]]: "Delete",
    [Project_Words["cloud_switch_modal_download_project"]]: "download .noli",
    [Project_Words["cloud_switch_modal_load_more"]]: "Load more",
    [Project_Words["cloud_project_header_op_icon_tooltip"]]: "Project managment",
    [Project_Words["cloud_project_delete_modal_warn"]]:
      "Do you confirm to delete project '$', this project can not be retrieved after deleted",
    [Project_Words["cloud_project_delete_modal_confirm"]]: "Delete",
    [Project_Words["cloud-save-success-message"]]: "Saved Successfully! 🥳",
    [Project_Words["cloud-save-failed-message"]]: "Saved Failed! 😫",
  },
};
